const btns = document.querySelectorAll(".s-work-btn");
const portfolio = document.querySelectorAll("[data-type='portfolio']");
const select = document.querySelector("#work");
const portfolioItems = document.querySelectorAll('.c-projectBox__item');

let heightAfter = 0;
let flag = 0;
let heightTab = [];


select.addEventListener("change", () => {
	portfolioItems.forEach(item => {
		if (item.classList.contains('c-projectBox')) {
			item.classList.add('hide');
		} else {
			item.parentElement.classList.add('hide');
		}

		item.classList.remove('fade-up', 'js-fade-up', 'is-visible');
	});

	if (select.value === "all") {
		portfolioItems.forEach((el, index) => {
			vissibleElement(el, heightAfter);
		});
	} else {
		portfolioItems.forEach((el, index) => {
			if (el.dataset.category === select.value) {
				vissibleElement(el);
			}
		});
	}

	fadeUp();
});

btns.forEach((btn) => {
	btn.addEventListener("click", (e) => {
		btns.forEach((btn) => {
			btn.classList.remove("active");
		});

		btn.classList.add("active");
		const category = btn.dataset.category;

		portfolioItems.forEach(item => {
			if (item.classList.contains('c-projectBox')) {
				item.classList.add('hide');
			} else {
				item.parentElement.classList.add('hide');
			}

			item.classList.remove('fade-up', 'js-fade-up', 'is-visible');
		});

		if (btn.dataset.category === "all") {
			portfolioItems.forEach((el, index) => {
				vissibleElement(el, heightAfter);
			});
		} else {
			portfolioItems.forEach((el, index) => {
				if (el.dataset.category === category) {
					vissibleElement(el);
				}
			});
		}

		fadeUp();
	});
}, false);

// //fadeup
function fadeUp() {
	const items = document.querySelectorAll(".js-fade-up");
	const options = { rootMargin: "0px 0px 0px 0px" };

	const observer = new IntersectionObserver((entries, observer) => {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {

				entry.target.classList.add("is-visible");

				observer.unobserve(entry.target);
			}
		});
	}, options);

	items.forEach((item) => {
		observer.observe(item);
	});
}

function vissibleElement(e, f) {
	if (e.classList.contains('c-projectBox')) {
		e.classList.remove('hide');
	} else {
		e.parentElement.classList.remove('hide');
	}

	e.classList.add('fade-up', 'js-fade-up');
}
